
const EpisodesLoadingState = () => {
  return (
    <div className="text-center py-20">
      <p className="text-2xl text-gray-600 mb-6">Loading episodes...</p>
    </div>
  );
};

export default EpisodesLoadingState;
